import React from 'react'
import { Field } from 'redux-form'
import renderSelect from '../fields/renderSelect'
import renderField from '../fields/renderField'
import i18n from '../../translations/i18n';

let BillingInformation = props => {
	const lng = props.lng;
	const deliveryAddressFilled = props.shippingCountry && props.shippingaddressline1 && props.shippingpostalcode && props.shippingcity;
	const isTranslation = (props.service==="translation")
	const isOfficial = (props.service==="official")
	const disabled = (deliveryAddressFilled && props.sameAddress && ((isTranslation&&props.certification)||isOfficial));

	return (
		<div>
			<div className="form-section">
				{deliveryAddressFilled&&((isTranslation&&props.certification)||isOfficial)&&<div className="row">
					<div className="col-12 form-input check-with-tooltip">
						<label className='simple-checkbox'>
							{i18n.t('billing.different_address', {lng})}
							<Field
								name="sameAddress"
								component="input"
								type="checkbox"
								label={i18n.t('billing.different_address', {lng})}
								onClick={props.sameAddressChange}
								value="sameAddress"
							/>
							<span className="checkboxmark"></span>
						</label>
					</div>
				</div>}
				<div className="row mb-5">
					<div className="col-12 form-input">
						<Field
							disabled={disabled}
							name="addressline1"
							type="text"
							component={renderField}
							label={i18n.t('billing.address_line_1', {lng})}
							placeholder={i18n.t('billing.address_line_1_placeholder', {lng})}
						/>
					</div>
					<div className="col-12 form-input">
						<Field
							disabled={disabled}
							name="addressline2"
							type="text"
							component={renderField}
							label={i18n.t('billing.address_line_2', {lng})}
							placeholder={i18n.t('billing.address_line_2_placeholder', {lng})}
						/>
					</div>
					<div className="col-12 col-sm-6 form-input">
						<Field
							disabled={disabled}
							name="postalcode"
							type="text"
							component={renderField}
							label={i18n.t('billing.postal_code', {lng})}
							placeholder={i18n.t('billing.postal_code_placeholder', {lng})}
						/>
					</div>
					<div className="col-12 col-sm-6 form-input">
						<Field
							disabled={disabled}
							name="city"
							type="text"
							component={renderField}
							label={i18n.t('billing.city', {lng})}
							placeholder={i18n.t('billing.city_placeholder', {lng})}
						/>
					</div>
					<div className="col-12 form-input">
						<Field
							disabled={disabled}
							name="billingCountry"
							component={renderSelect}
							label={i18n.t('billing.country', {lng})}
							options={props.countries}
							placeholder={i18n.t('app.please_select', {lng})}
						/>
					</div>
					{(props.billingCountry==="United States") && <div className="col-12 form-input">
						<Field
							disabled={disabled}
							name="billingState"
							component={renderField}
							label={i18n.t('billing.state', {lng})}
						/>
					</div>}
					{(props.userType==="company") && <div className="col-12 form-input">
						<Field
							name="vatNumber"
							type="text"
							component={renderField}
							label={i18n.t('billing.vat', {lng})}
						/>
					</div>}
				</div>
				<div className="row mb-5">
					<div className="col-12 col-sm-10 mx-auto">
						<Field
							name="couponCode"
							type="text"
							component={renderField}
							label={i18n.t('billing.coupon_code', {lng})}
							confirmed={props.coupon > 0 ? 'true' :'false'}
						/>
					</div>
				</div>
				<div>
					<div className="col-12 col-sm-10 mx-auto">
						<label className="simple-checkbox">
							{i18n.t('billing.terms_and_conditions_link_part1', {lng})}
							<a href="https://davrontranslations.com/faqs/terms-of-use-and-privacy-policy/"> {i18n.t('billing.terms_and_conditions_link_part2', {lng})}</a>
								<Field
									name="termsAndConditions"
									component="input"
									type="checkbox"
									label={i18n.t('billing.terms_and_conditions_check', {lng})}
									value="termsAndConditions"
								/>
							<span className="checkboxmark"></span>
						</label>
					</div>
				</div>
				<div>
					<div className="col-12 col-sm-10 mx-auto form-input">
						<label className="simple-checkbox">
						{i18n.t('billing.newsletter_title', {lng})}
						<Field
							name="newsletterConsent"
							component="input"
							type="checkbox"
							label={i18n.t('billing.newsletter_check', {lng})}
							value="newsletterConsent"
						/>
						<span className="checkboxmark"></span>
						</label>
					</div>
				</div>
			</div>
	</div>
	)
}


export default BillingInformation



// WEBPACK FOOTER //
// ./src/components/common/billingInformation.js